module.exports = __webpack_public_path__ + "./images/p11.JPG?fadad861689430e167d13abbc6d516a0";


//////////////////
// WEBPACK FOOTER
// ./src/products/p11.JPG
// module id = 46
// module chunks = 0